var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _path9, _path0, _path1, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileskillicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    viewBox: "0 0 44 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70081 16.6284H43.2721V43.8807C43.2721 44.9011 42.4449 45.7283 41.4245 45.7283H3.54842C2.52801 45.7283 1.70081 44.9011 1.70081 43.8807V16.6284Z",
    fill: "#FEC353"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2719 43.8809C43.2719 44.9013 42.4446 45.7285 41.4242 45.7285H22.4847V19.4004H43.2719V43.8809Z",
    fill: "#FF9E39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70081 14.5023C1.70081 13.1647 2.5727 11.9833 3.85086 11.5891L38.5123 0.898311C40.1212 0.402075 41.8277 1.30405 42.324 2.91294L43.0591 5.29641L1.70081 18.2912L1.70081 14.5023Z",
    fill: "#4E5E82"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8017 3.5858L33.9818 2.29652L29.8523 9.44683L25.6552 10.7655L29.8017 3.5858Z",
    fill: "#E2E6F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3014 6.51602L24.4815 5.22674L20.3134 12.4439L16.1163 13.7627L20.3014 6.51602Z",
    fill: "#E2E6F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5526 9.52289L14.7333 8.23343L10.5963 15.4971L6.39893 16.8159L10.5526 9.52289Z",
    fill: "#E2E6F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0674 7.80825L38.9009 1.17041C39.9191 1.28186 40.8715 1.73438 41.6004 2.44474L39.2645 6.48953L35.0674 7.80825Z",
    fill: "#E2E6F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.70081,
    y: 16.6284,
    width: 41.5713,
    height: 5.54283,
    fill: "#3E4466"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2715 17.73L38.0703 22.1714H33.8027L40.2949 16.6284H43.2715V17.73Z",
    fill: "#CED6E7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4999 22.1714H24.2323L30.7245 16.6284H34.9921L28.4999 22.1714Z",
    fill: "#CED6E7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7997 22.1714H14.5321L21.0243 16.6284H25.2919L18.7997 22.1714Z",
    fill: "#CED6E7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25537 22.1714H3.98779L10.48 16.6284H14.7476L8.25537 22.1714Z",
    fill: "#CED6E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.24512,
    y: 27.7144,
    width: 30.4856,
    height: 1.38571,
    rx: 0.692854,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.24512,
    y: 38.7998,
    width: 30.4856,
    height: 1.38571,
    rx: 0.692854,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1741,
    y: 27.7144,
    width: 1.38571,
    height: 12.4714,
    rx: 0.692854,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4136,
    y: 27.7144,
    width: 1.38571,
    height: 12.4714,
    rx: 0.692854,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileskillicon);
export default __webpack_public_path__ + "static/media/profileskillicon.8fc9700c9c7a77da58df7dae19310a26.svg";
export { ForwardRef as ReactComponent };